// extracted by mini-css-extract-plugin
export default {"dnb_menuBottomBar":"MenuBottomBar-module--dnb_menuBottomBar--67063","link":"MenuBottomBar-module--link--7eb83"};